import {
  TTranslationAppearanceForm,
  TTranslationAppearanceTheme,
} from '@/page/general-settings/appearance/appearance.ts';

const appearanceForm: TTranslationAppearanceForm = {
  colorTheme: {
    label: 'Motyw kolorystyczny',
    tooltip: 'Określa kolory Qmulus. Każdy podgląd pokazuje motyw w wybranej gęstości.',
  },
  density: {
    label: 'Gęstość',
    tooltip: 'Określa, ile miejsca Qmulus pozostawia między elementami. Kompaktowa pokazuje więcej treści naraz, szeroka daje elementom więcej miejsca.',
  },
  locale: {
    label: 'Język',
    tooltip: 'Pozwala wybrać żądany język i ustawienia regionalne interfejsu użytkownika.',
  },
  fontSize: {
    label: 'Skalowanie strony',
    tooltip: 'Pozwala doZastosuj rozmiar czcionki i elementu interfejsu użytkownika.',
  },
  chartTimeFormat: {
    label: 'Format czasu wykresu',
    tooltip: 'Określa sposób wyświetlania dat i znaczników czasu na osi X wykresów.',
  },
  unitSystem: {
    label: 'System jednostek',
    tooltip: 'Wybierz preferowane jednostki miary (np. metryczne lub imperialne) do wyświetlania wartości',
  },
  scaleOption: {
    label: 'Skalowanie układu',
    tooltip: 'Określa sposób wyświetlania skalowania układu sklepu.',
  },
  showOnlyAvailableApps: {
    label: 'Ukryć nieaktywne aplikacje?',
    tooltip: 'Ukrywa aplikacje, które nie są dostępne, aby interfejs użytkownika był bardziej przejrzysty.',
  },
  hasOptedOutOfReleaseHighlights: {
    label: 'Pokazywać nowości po aktualizacjach?',
    tooltip: 'Po aktualizacji jednorazowo pokazuje nowości nowych wersji Qmulus. Są zawsze dostępne na stronie, która otwiera się po kliknięciu numeru wersji w menu użytkownika.',
  },
};

const appearanceTheme: TTranslationAppearanceTheme = {
  colorThemeOption: {
    'qmulus-light': 'Qmulus jasny',
    'qmulus-g10': 'Qmulus szary 10',
    'qmulus-g90': 'Qmulus szary 90',
    'qmulus-dark': 'Qmulus ciemny',
    'aichelin-light': 'Aichelin jasny',
    'aichelin-dark': 'Aichelin ciemny',
    'pt9000-modern': 'PT9000 nowoczesny',
    'pt9000': 'PT9000',
    'galaxy-desert': 'Galaxy pustynny',
    'galaxy-snow': 'Galaxy śnieżny',
    'galaxy-void': 'Galaxy próżniowy',
    'galaxy-ember': 'Galaxy żarowy',
  },
  densityOption: {
    compact: 'Kompaktowa',
    regular: 'Standardowa',
    wide: 'Szeroka',
  },
};

export default {
  subline: 'Zmień wygląd i odczucia Qmulusa',
  appearanceForm,
  appearanceTheme,
};
